import { render, staticRenderFns } from "./ProfitRatePerResource.vue?vue&type=template&id=243a1238&"
import script from "./ProfitRatePerResource.vue?vue&type=script&lang=js&"
export * from "./ProfitRatePerResource.vue?vue&type=script&lang=js&"
import style0 from "./ProfitRatePerResource.vue?vue&type=style&index=0&id=243a1238&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports